import api from '../../store/config/api';
import { THREAD as SCHEMA, THREAD_LIST } from '../../schemas';

export const [
  GET_THREAD,
  GET_THREAD_REQUEST,
  GET_THREAD_SUCCESS,
  GET_THREAD_FAILURE
] = api.buildTypes('GET_THREAD');

export function getRunThread({ teamName, runID, includeChildren = true }) {
  return {
    type: GET_THREAD,
    payload: {
      url: `/teams/${teamName}/runs/${runID}/thread?includeChildren=${includeChildren}`,
      schema: SCHEMA,
      options: {
        method: 'GET'
      }
    }
  };
}

export const [
  GET_THREAD_LIST,
  GET_THREAD_LIST_REQUEST,
  GET_THREAD_LIST_SUCCESS,
  GET_THREAD_LIST_FAILURE
] = api.buildTypes('GET_THREAD');

export function getThreadList({ teamName, includeChildren = true }) {
  return {
    type: GET_THREAD_LIST,
    payload: {
      url: `/teams/${teamName}/threads?includeChildren=${includeChildren}`,
      schema: THREAD_LIST,
      options: {
        method: 'GET'
      }
    }
  };
}



// WEBPACK FOOTER //
// ./js/actions/api/thread.js